import React, { useMemo } from 'react';

import { MassMessageRolesGroup, MassMessageRole } from 'models';

import isRolesGroup from 'utils/isRolesGroup';
import keyBy from 'lodash/keyBy';
import has from 'lodash/has';

import RolesGroup from './roles-group';
import RoleItem from './role-item';

import { useStyles } from './style';

interface RolesSelectionListProps {
  disabled?: boolean;
  rolesEntities: (MassMessageRolesGroup | MassMessageRole)[];
  selectedRoles: MassMessageRole[];
  onSelectRoles?: (roles: MassMessageRole[], checked: boolean) => void;
}

const RolesSelectionList = ({
  disabled = false,
  rolesEntities,
  onSelectRoles,
  selectedRoles,
}: RolesSelectionListProps) => {
  const classes = useStyles();

  const selectedRolesDict = useMemo(
    () => keyBy(selectedRoles, 'Id'),
    [selectedRoles]
  );

  return (
    <ul className={classes.ul}>
      {rolesEntities.map((rolesEntity) => {
        return (
          <React.Fragment key={rolesEntity.Name}>
            {isRolesGroup(rolesEntity) ? (
              <RolesGroup
                key={rolesEntity.Name}
                disabled={disabled || !!!rolesEntity.Roles.length}
                group={rolesEntity}
                selectedRoles={selectedRoles}
                onSelectRoles={onSelectRoles}
              />
            ) : (
              <RoleItem
                disabled={disabled}
                role={rolesEntity}
                onSelectRole={onSelectRoles}
                selected={has(selectedRolesDict, rolesEntity.Id)}
              />
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};

export default RolesSelectionList;
